import { render, staticRenderFns } from "./InsightsStandalone.vue?vue&type=template&id=06c9aad2&scoped=true"
import script from "./InsightsStandalone.vue?vue&type=script&lang=js"
export * from "./InsightsStandalone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9aad2",
  null
  
)

export default component.exports